import { Box, TextField, Typography, useTheme, useMediaQuery } from "@mui/material";
import React, { useContext, useState, useRef, useEffect } from "react";
import theme from "../theme";
import TicketCard from "./TicketCard";
import { AutoTaskAuthContext } from "../Context/AutoTaskContext";


const FILTER_LABELS = {
  pending: "Pending",
  resolved: "Resolved",
};

const RaisedTickets = ({ tickets }) => {
  const { userInfo } = useContext(AutoTaskAuthContext) || {};
  const user_id = userInfo?.id;

  const [filterByDate, setFilterByDate] = useState(
    new Date().toISOString().split("T")[0] // ✅ yyyy-mm-dd
  );
  const [filters, setFilters] = useState({ tab: "pending" });

  const [indicatorStyle, setIndicatorStyle] = useState({});
  const tabRefs = useRef([]);

  // ✅ Responsive check
  const resTheme = useTheme();
  const isMobile = useMediaQuery(resTheme.breakpoints.down("md"));

  // update indicator style when tab changes
  useEffect(() => {
    if (tabRefs.current[filters.tab]) {
      const el = tabRefs.current[filters.tab];
      setIndicatorStyle({
        left: el.offsetLeft,
        width: el.offsetWidth,
      });
    }
  }, [filters.tab]);

  const handleTabChange = (tabKey) => {
    setFilters((prev) => ({ ...prev, tab: tabKey }));
  };

  // 1️⃣ Filter tickets not assigned to current user
  // let filteredTickets = tickets.filter(
  //   (ticket) => ticket.assigned_to !== user_id
  // );

   let filteredTickets = tickets.filter((ticket)=>ticket.type==="external")
  // 2️⃣ Further filter by date + tab (pending vs resolved)
  filteredTickets = filteredTickets.filter((ticket) => {
    // const createdDate = ticket.created_at.split("T")[0]; // "yyyy-mm-dd"

    // // must match selected date
    // if (createdDate !== filterByDate) return false;

    if (filters.tab === "resolved") {
      return ticket.status === "resolved";
    } else {
      // Pending = open or in_progress
      return ticket.status === "open" || ticket.status === "in_progress";
    }
  });

  return (
    <Box
     sx={{
          // mt: !isMobile ? 2 : 0,
          // mb: 10,
          mx: "auto",
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          
        }}
    >
      {/* Tabs Header */}
      <Box
        sx={{
          width: isMobile ? "100vw" : "100%",
          marginX: isMobile ? -2 : 0,
          boxShadow: !isMobile ? "0 2px 5px #bdbdbd" : "none",
          bgcolor: "#fff",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: isMobile ? "100vw" : "240px", // only two tabs
            px: isMobile ? 2 : 0,
            // position: isMobile ? "fixed" : "static",
            background: isMobile ? theme.lightTheme.header.home : "#fff",
            height: isMobile ? "50px" : "36px",
            alignItems: isMobile ? "end" : "center",
            zIndex: 1000,
          }}
        >
          {Object.entries(FILTER_LABELS).map(([key, label]) => {
            const isActive = filters.tab === key;
            return (
              <Typography
                key={key}
                ref={(el) => (tabRefs.current[key] = el)}
                onClick={() => handleTabChange(key)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: isMobile?"76%":"100%",
                  width: "120px",
                  background: isMobile
                    ? isActive
                      ? "#fff"
                      : ""
                    : isActive
                    ? "linear-gradient(90deg,rgba(0, 128, 128, 1) 0%, rgba(68, 40, 160, 1) 100%)"
                    : "#fff",
                  borderRadius: isMobile ? "8px 8px 0 0" : "0",
                  fontSize: isMobile ?12:14,
                  py: 0.5,
                  cursor: "pointer",
                  color: isMobile
                    ? isActive
                      ? "black"
                      : "#fff"
                    : isActive
                    ? "#fff"
                    : "black",
                  fontWeight: isActive ? 600 : 400,
                  transition: "all 0.2s ease",
                }}
              >
                {label}
              </Typography>
            );
          })}
        </Box>
      </Box>

      {/* Date filter
      <Box
        sx={{
          my: 2,
          width: "100%",
          display: "flex",
          gap: 2, // spacing between date and button
        }}
      >
        <TextField
          type="date"
          label="Select Date"
          size="small"
          fullWidth
          value={filterByDate}
          onChange={(e) => setFilterByDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{
            "& label.Mui-focused": { color: "inherit" },
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": { borderColor: "inherit" },
            },
          }}
        />
      </Box> */}
  {/* Ticket List */}
  <Box
  sx={{
    mt: 1,
    mb: 0,
    mx: "auto",
    width: "100%",
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
    gap: isMobile ? "8px" : "0 10px", // ✅ same gap values as first block
  }}
>
  {filteredTickets.length === 0 ? (
    <Typography
      sx={{
        color: theme.textCol.subHeading,
        mt: 3,
        textAlign: "center",
        gridColumn: "1 / -1", // ✅ spans across all grid columns
      }}
    >
      No tickets found
    </Typography>
  ) : (
    filteredTickets.map((ticket, index) => (
      <Box
        key={`${ticket.id}-${index}`}
        sx={{
          borderRadius: 1,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          py: !isMobile ? 0.8 : 0, // ✅ same padding values
          px: !isMobile ? 0.8 : 0, // ✅ same padding values
        }}
      >
        <TicketCard
          filteredTickets={filteredTickets}
          index={index}
          ticket={ticket}
        />
      </Box>
    ))
  )}
</Box>


    </Box>
  );
};

export default RaisedTickets;
